/**
 * Trinidad and Tobago dollar.
 */
export var TTD = {
  code: 'TTD',
  base: 10,
  exponent: 2
};